import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import ToolActionButtons from "../../Components/ToolActionButtons";
import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { XMLFormat, XMLMinify } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { exampleXML, MinifiedXML } from "../../Services/Tools";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";


function XMLFormatter() {
    const [text, setText] = useState("");
    const [beautifyReqBody, setBeautifyReqBody] = useState();
    const [minifyReqBody, setMinifyReqBody] = useState();
    const [result, setresult] = useState("")
    const indent = 2;
    const toolFav = { toolName: 'XML Formatter', Iconpath: "/FileCodeRaw.svg" };
    const [activeAction, setActiveAction] = useState("minify");
    const [, setIsValid] = useState(true);


    

    


    const lineCount = text !== "" ? (text || "").split("\n").length : 0;
    const resultLineCount = result !== "" ? (result ?? "").toString().split("\n").length : 0;

    const handleChange = (e) => {
        setText(e.target.value);
        setBeautifyReqBody({
            input: e.target.value,
            indent: indent
        });
        setMinifyReqBody({
            input: e.target.value
        });
    };


    const formatXML = () => {
        if (activeAction === "minify") {
            MinifyXML();
        }
        else {
            BeautifyXML();
        }
    }

    const pasteExample = () => {
        if (activeAction === "minify") {
            const exampleText =
                typeof exampleXML === "string"
                    ? exampleXML
                    : JSON.stringify(exampleXML, null, indent);

            setText(exampleText);
            setMinifyReqBody({
                input: exampleText,
            });
        }
        else {
            const exampleText = MinifiedXML;
            setText(exampleText);
            setBeautifyReqBody({
                input: exampleText,
                indent: indent
            });
        } 
    };


    const handleImport = (filecontent) => {
        setText(filecontent);

        setBeautifyReqBody({
            input: filecontent,
            indent: indent
        });

        setMinifyReqBody({
            input: filecontent,
        });

    };

    const MinifyXML = async () => {
        try {
            const response = await XMLMinify(minifyReqBody);
            setresult(response.data.minifiedXml);
            setIsValid(true);
        } catch (error) {
            if (error.response?.status === 400 || error.response?.status === 500) {
                const apiMessage =
                    error.response?.data?.message;
                setresult(apiMessage);
                setIsValid(false);
            } else {
                setresult("Something went wrong. Please try again.");
                setIsValid(false);
            }
        }
    };

    const BeautifyXML = async () => {
        try {
            const response = await XMLFormat(beautifyReqBody);
            setresult(response.data.formattedXml);
            setIsValid(true);
        } catch (error) {
            if (error.response?.status === 400 || error.response?.status === 500) {
                const apiMessage =
                    error.response?.data?.message;
                setresult(apiMessage);
                setIsValid(false);
            } else {
                setresult("Something went wrong. Please try again.");
                setIsValid(false);
            }
        }
    };

    const runAction = async (action) => {
        setActiveAction(action);
        setText("");
        setresult("");
    }
    return (
        <>
            <Col>
                <ToolHeader title="XML Formatter" description="Format and validate XML data" toolFav={toolFav} />

                <ToolActionButtons
                    actions={[
                        { label: "Minify", value: "minify" },
                        { label: "Beautify", value: "beautify" }
                    ]}
                    activeValue={activeAction}
                    onAction={(action) => runAction(action.value)}
                />

                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input XML"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder="Paste your XML here..."
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setBeautifyReqBody("");
                                        setMinifyReqBody("");
                                        setresult("");
                                    }}
                                    onImport={(fileContent) => handleImport(fileContent)}
                                    accept=".xml"
                                    executeLabel={"Format"}
                                    showExecute={true}
                                    onExecute={formatXML}
                                />
                            }
                            footerLeft={`Characters : ${String(text ?? "").replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text ?? ""]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Formatted XML"
                            value={result ?? ""}
                            placeholder="Formatted JSON will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName="formatted.xml"
                                    mimeType="application/json;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${String(result ?? "").replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default XMLFormatter;
